import React, { Fragment } from 'react'
import './style.css'

export default function Profile(props) {
    return (
        <div className='Home_SpaceBasedPlan'>
            <div className='Home_SpaceBasedPlan_MainTitle'>遥感卫星应用国家工程研究中心</div>
            <div className='Home_SpaceBasedPlan_Imgs2'>
                <img className='Home_SpaceBasedPlan_Img_Profile' src="images/Introduce/Profile/1.png" />
            </div>
            <div className='Home_SpaceBasedPlan_FirstTitle'>中心简介：</div>
            <div className='Home_SpaceBasedPlan_SecondIntroduceText'>遥感卫星应用国家工程研究中心（以下简称“工程中心”）前身为 2008 年由国家发展改革委批准成立的遥感卫星应用国家工程实验室，2021 年 12 月正式纳入国家工程研究中心新序列管理。工程中心的上级主管部门为中国科学院，牵头建设单位为中国科学院空天信息创新研究院（以下简称“空天院”），联合北京二十一世纪空间技术应用股份有限公司（以下简称“世纪空间”）共建，是遥感卫星应用国家创新体系的重要组成部分。</div>
            <div className='Home_SpaceBasedPlan_FirstTitle'>人才队伍：</div>
            <div className='Home_SpaceBasedPlan_SecondIntroduceText'>人才队伍截至 2021 年底，中心共有研究与试验发展人数 310 人，其中高级专家 9 人，博士 122 人；来中心从事研发工作的外部专家 29 人。拥有两院院士、国际院士 4 人，杰青 1 人，优青 1 人，百人计划 3 名，万人计划 2 名，入选中科院青促会 11 人。培养学生 234 人（含在读），其中博士 94 人，硕士 140 人。获北京市优秀毕业生 2 人，中科院院长优秀奖 1 人、朱李月华优博奖 1 人。</div>
            <div className='Home_SpaceBasedPlan_FirstTitle'>使命定位：</div>
            <div className='Home_SpaceBasedPlan_SecondIntroduceText'>以服务国家重大战略任务和实施国家重大卫星应用工程为导向，组织产学研用协同攻关，突破制约高质量规模化应用关键问题，构建遥感应用工程化研究和技术成果验证平台。通过搭建遥感科技创新和产业发展的桥梁，培养工程技术创新人才，促进产业数字化和数字产业化，为高质量经济发展提供新动能。</div>
            <div className='Home_SpaceBasedPlan_FirstTitle'>建设目标：</div>
            <div className='Home_SpaceBasedPlan_SecondIntroduceText'>标面向航天强国、科技强国建设，打造国家级卫星应用服务地面基础设施，实施国家重大卫星应用工程，转化和推广卫星应用科技成果，构建产学研用一体的工程化应用创新链条。重点突破卫星遥感数据接收、处理、检验、共享服务系列关键技术，研发核心技术装备、数据与信息产品，完善自主遥感卫星应用标准，建立链路完整、自主可控的遥感卫星应用工程技术体系。</div>

        </div>
    )
}